import * as bootstrap from 'bootstrap';

const nuffleSqueakDuration = 200;
let nuffleSqueakTimeout: number = 0;

const onload = () => {
  const nuffle = document.getElementById("nuffle-squeaker");
  if (nuffle) {
    const sqek = document.getElementById("sqek") as HTMLAudioElement;
    const nuffleSqueaked = document.getElementById("nuffle-squeaked");
    const nuffleUnsqueaked = document.getElementById("nuffle-unsqueaked");

    const doSqueak = () => {
      if (sqek) {
        sqek.play().catch((error) => {
          console.error("Error playing sound:", error);
        });
      }

      if (!nuffleSqueaked || !nuffleUnsqueaked) {
        return;
      }


      nuffleUnsqueaked.classList.add("d-none");
      nuffleSqueaked.classList.remove("d-none");

      nuffleSqueakTimeout = Date.now() + nuffleSqueakDuration;

      setTimeout(() => {
        if (Date.now() < nuffleSqueakTimeout) {
          return;
        }

        nuffleSqueaked.classList.add("d-none");
        nuffleUnsqueaked.classList.remove("d-none");
      }, nuffleSqueakDuration);
    }

    nuffle.onclick = doSqueak;
  }
}

if (document) {
  document.addEventListener("DOMContentLoaded", onload);
}